import { useTranslation } from 'react-i18next';
import { TeleportIcon } from '@icons';
import { useMytaverseEvent } from '@core/dashboard/providers';
import HomeBarButton from '../../HomeBarButton';
import { NOTIFICATION_TYPES, useNotification } from '@components/Notification';
import { getClientSpecificCanTeleport } from '@helpers/clientSpecificUtils';
import { getNotification } from '@components/Notification/helpers';
import { Box } from '@mui/material';
import {
  useClientSpecificDashboardButtonDisabled,
  useClientSpecificTeleportVisibility,
} from '@hooks/clientSpecificUtils';
import { DashboardButtonEnum } from '@constants/dashboard';
import {
  useHasTeleportDestinations,
  useTeleportOpen,
} from '@core/dashboard/components/TeleportModal/hooks/useTeleportOpen';
import { useHiddenWhileEditing } from '@core/dashboard/hooks/useHiddenWhileEditing';

const Teleport = () => {
  const { t: translate } = useTranslation();
  const { isTeleportingToRoomByUnreal, currentEvent, teleportEnabled } =
    useMytaverseEvent();
  const isHiddenWhileEditing = useHiddenWhileEditing();
  const { showNotification } = useNotification();
  const { canTeleport, notificationMessage } =
    getClientSpecificCanTeleport(currentEvent);

  const isDisabledClientSpecific = useClientSpecificDashboardButtonDisabled(
    DashboardButtonEnum.TELEPORT_BUTTON,
  );
  const { isTeleportFeatureEnabled } = useClientSpecificTeleportVisibility();
  const hasTeleportDestinations = useHasTeleportDestinations();

  const {
    toggleTeleport,
    open: isTeleportModalOpen,
    hasMapTeleportPreviews,
  } = useTeleportOpen();

  const handleTeleportClick = () => {
    toggleTeleport();
  };

  const showNotificationIfCantTeleport = () => {
    showNotification(
      getNotification({
        message: translate(`notifications.${notificationMessage}`),
        type: NOTIFICATION_TYPES.INFO,
        closeManually: false,
        withDismissButton: false,
        withReloadButton: false,
      }),
    );
  };

  // Hide the trigger while the branding editor's Inspector is open (MV-1551) so
  // it isn't clickable over the editor — the teleport menu it opens is hidden
  // for the same reason. Only the render is gated; the teleport store is left
  // intact, so prior open state is preserved when the Inspector closes.
  if (isHiddenWhileEditing) {
    return null;
  }

  if (teleportEnabled && isTeleportFeatureEnabled && hasTeleportDestinations) {
    return (
      <Box
        onClick={() => {
          !canTeleport && showNotificationIfCantTeleport();
        }}
      >
        <HomeBarButton
          handleClick={handleTeleportClick}
          icon={<TeleportIcon />}
          label={translate('tooltips.teleport')}
          isActive={
            hasMapTeleportPreviews
              ? isTeleportModalOpen
              : isTeleportingToRoomByUnreal
          }
          disabled={!canTeleport || isDisabledClientSpecific}
        />
      </Box>
    );
  } else {
    return null;
  }
};

export default Teleport;
